import { Box, Grid } from "theme-ui";
import { ScoresObject } from "../../types";
import { useTranslations } from "../../contexts/Translation";
import EmScore from "../Survey/EmScore";

type ComponentProps = {
  scores: ScoresObject | string | undefined;
  selected: string[];
  status?: string;
  compareTo?: ScoresObject | null;
  questions: string[];
};

const getScoreObject = (questions: string[], scoreString: string) => {
  const scoresObject = {} as ScoresObject;
  scoreString.split(',').forEach((score, index) => {
    const parsedScore = Number(score);
    scoresObject[questions[index] as keyof ScoresObject] = 
      isNaN(parsedScore) ? undefined : parsedScore;
  });
  return scoresObject;
};

const QuestionScores = ({ questions, scores, selected, status, compareTo = null }: ComponentProps) => {
  const t = useTranslations('improvementGoals');
  if (!scores) {
    return null;
  }

  const scoresObj = typeof scores === 'string' ? getScoreObject(questions, scores): scores;

  return (
    <Box>
      <Grid sx={{ justifyItems: 'center', gridTemplateColumns: 'repeat(4, 1fr)', gridTemplateRows: 'repeat(1, 1fr)' }}>
        {scores && questions.map(question => {
          const isSelected = selected.includes(question);
          let diff = 0;

          if (compareTo && compareTo[question as keyof ScoresObject]) {
            const scoreValue = scoresObj[question as keyof ScoresObject];
            const compareValue = compareTo[question as keyof ScoresObject];
            if (scoreValue !== undefined && compareValue !== undefined) {
              diff = scoreValue - compareValue;
            }
          }

          return (<Box key={question} >
            <Box sx={{
              p: 24,
              outline: '1px solid #bbb',
              outlineStyle: 'solid',
              outlineWidth: isSelected ? '3px': '1px',
              outlineColor: isSelected ? 'mainText': 'muted',
              opacity: isSelected ? '1' : '.5',
              fontSize: 32,
              borderRadius: 8 }}>
              <EmScore afterSx={{ bottom: '-1.2em' }} size={3} status={status} score={scoresObj[question as keyof ScoresObject]} after={t(`questions.${question}Label`)} />
            </Box>
            { compareTo && compareTo[question as keyof ScoresObject] && (
              <Box sx={{
                fontFamily: 'interaction',
                fontWeight: 'bold',
                fontSize: 24,
                textAlign: 'center',
                color: diff === 0 || !isSelected ? 'unknown' : diff > 0 ? 'positive' : 'negative', 
                mt: 8 }}>
                  { compareTo[question as keyof ScoresObject] === 0 || scoresObj[question as keyof ScoresObject] === 0 || isNaN(diff) ? '-' : 
                    <>
                      {diff.toFixed(1)} { diff === 0 ? '→' : diff > 0 ? '↗' : '↘'}
                    </>
                  }
              </Box>
            )}
          </Box>);
        })}
      </Grid>
    </Box>
  )
};

export default QuestionScores;
